module.exports = __webpack_public_path__ + "static/media/02.a34d1370.jpg";